import { fontFamily } from "./fontList";

const fontChange = (getFont: string): string => {
  return fontFamily[getFont as keyof typeof fontFamily];
};

export default fontChange;
